import React from 'react';
import { Button } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';

export default function buttonComponent(props) {
	const {
		analyticsTrackTitle,
		analyticsTitle,
		windowLocationHref,
		buttonName,
		iconVisible,
		style,
		buttonShape,
	} = props;

	// Shape classes from Strapi; omit when unset so legacy style-only buttons stay unchanged
	const buttonClass =
		buttonShape === 'rectangle'
			? 'btn-rectangle'
			: buttonShape
				? 'btn-round'
				: undefined;

	return (
		<Button
			className={buttonClass}
			style={style}
			onClick={() =>
				window.analytics.track(analyticsTrackTitle, {
					title: analyticsTitle,
					action: 'Clicked',
					location: windowLocationHref,
				})
			}
		>
			{buttonName !== null ? buttonName : ''}{' '}
			{iconVisible ? <ChevronRight className='btn-icon' size={18} /> : ''}
		</Button>
	);
}
